<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="section-panel-header">
        <mat-panel-title>
            <app-section-header
                [title]="sectionDescription.title"
                [description]="sectionDescription.description"
            ></app-section-header>
        </mat-panel-title>
    </mat-expansion-panel-header>
    @if (!paidToMultipleFacilitiesEnableControl.value) {
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Facility ID</mat-label>
            <input matInput formControlName="paidToFacilityId" required id="facility-id" type="text" inputmode="text" />
            <mat-hint>{{ fieldHints.facilityId }}</mat-hint>
        </mat-form-field>
        @if (facilityIdControl.invalid) {
            @if (facilityIdControl.hasError('required')) {
                <mat-error>This field is required</mat-error>
            }
            @if (facilityIdControl.hasError('pattern')) {
                <mat-error>Only letters and numbers are allowed</mat-error>
            }
        }
    } @else {
        <div formArrayName="paidToFacilitiesId">
            @for (group of paidToFacilityGroups; track $index; let i = $index) {
                <div [formGroupName]="i">
                    <app-paid-to-facility-pair
                        [group]="group"
                        [showRemove]="paidToFacilitiesIdArray.length > 1"
                        (remove)="removePaidToFacility(i)"
                    ></app-paid-to-facility-pair>
                </div>
            }

            <button
                mat-stroked-button
                color="primary"
                type="button"
                id="add-paid-to-facility"
                (click)="addPaidToFacility()"
            >
                Add Facility
            </button>
        </div>
    }

    <div class="d-flex flex-wrap gap-3 mt-2">
        <div class="payment-toggle-item">
            <mat-slide-toggle id="allow-payment-multiple-facilities" formControlName="paidToMultipleFacilitiesEnable">
                Allow payment to multiple facilities
            </mat-slide-toggle>
            <p class="cargo-caption">{{ fieldHints.allowPaymentMultipleFacilities }}</p>
        </div>
        <div class="payment-toggle-item">
            <mat-slide-toggle id="allow-multiple-payments" formControlName="allowMultiplePayments">
                Allow multiple payments
            </mat-slide-toggle>
            <p class="cargo-caption">{{ fieldHints.allowMultiplePayments }}</p>
        </div>
        <div class="payment-toggle-item">
            <mat-slide-toggle id="require-customer-reference" formControlName="customerReferenceRequired">
                Require Customer Reference
            </mat-slide-toggle>
            <p class="cargo-caption">{{ fieldHints.requireCustomerReference }}</p>
        </div>
    </div>
</mat-expansion-panel>
